import styles from './TwoColumnContent.module.scss'

export default function TwoColumnContent(props) {
  const { columnOneContent, columnTwoContent } = props.fields

  return (
    <>
      <div className="container">
        <div className={styles.TwoColumnContentSection} data-aos="fade-up">
          <div className={styles.WYSIWYGWrapper}>
            <div
              className={styles.WYSIWYG}
              dangerouslySetInnerHTML={{
                __html: columnOneContent
              }}
            ></div>
          </div>

          <div className={styles.WYSIWYGWrapper}>
            <div
              className={styles.WYSIWYG}
              dangerouslySetInnerHTML={{
                __html: columnTwoContent
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  )
}
